import { AxiosMethod } from "../entities/Environment";
import request from "../axios/axios";
import type {  AxiosRequestConfig } from "axios";
import { CommonResponseInterface } from "../entities/Common";
import { CondimentInterface, HarmonyInterface } from "../entities/Condiment";

export enum CondimentEndpoints {
  CONDIMENT = "condiment",
  CONDIMENT_PRICES = "condiment-price",
  CONDIMENT_HARMONY = "condiment/harmony",
}

export class CondimentService {
  static getCondiments(
    config?: AxiosRequestConfig,
  ): Promise<CommonResponseInterface<CondimentInterface>> {
    return request({
      url: CondimentEndpoints.CONDIMENT,
      method: AxiosMethod.GET,
      params: config?.params,
    });
  }

  static getCondiment(id: string): Promise<CondimentInterface> {
    return request({
      url: `${CondimentEndpoints.CONDIMENT}/${id}`,
      method: AxiosMethod.GET,
    });
  }

  static getHarmonies(id: string): Promise<HarmonyInterface> {
    return request({
      url: `${CondimentEndpoints.CONDIMENT_HARMONY}/${id}`,
      method: AxiosMethod.GET,
    });
  }
}
